import { Icon, type IconProps, type IconName } from '@/components/Icon'
import type { QuestionIconType } from '@/features/jobs/questions/question-icon-type'

interface QuestionIconStyle {
  name: IconName
  color: string
}

const unknownIcon: QuestionIconStyle = {
  name: 'legend-builder-breaker',
  color: '#000',
}

const icons: Record<QuestionIconType, QuestionIconStyle> = {
  'yes-no': { name: 'legend-builder-yes-no', color: '#007be7' },
  text: { name: 'legend-builder-text', color: '#5ab3ff' },
  numeric: { name: 'legend-builder-numeric', color: '#5ab3ff' },
  'date-time': { name: 'legend-builder-datetime', color: '#e91e63' },
  'document-upload': {
    name: 'legend-builder-document-upload',
    color: '#0967b9',
  },
  choice: { name: 'legend-builder-choice', color: '#40a0f4' },
  breaker: { name: 'legend-builder-breaker', color: '#645efe' },
}

export interface QuestionIconProps extends Omit<Partial<IconProps>, 'type'> {
  type: QuestionIconType | undefined | null
}

/**
 * Question icon.
 */
export function QuestionIcon({ type, ...rest }: QuestionIconProps) {
  const icon = type ? icons[type] : unknownIcon
  return <Icon color={icon.color} name={icon.name} {...rest} />
}
